<template>
  <div class="sort-bar">
    <div
      v-for="(item, i) in service.sortBar"
      :key="i"
      @click="onOrderBy(i, sortBarOrderBy)"
      :class="i === sortBarIndex ? 'active' : ''"
    >
      {{ item.text }}
      <i :class="'sort-icon ' + (i === sortBarIndex ? sortBarOrderBy : '')"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    service: Object,
  },
  data() {
    return {
      sortBarIndex: -1,
      sortBarOrderBy: "", //asc / desc
    };
  },
  methods: {
    onOrderBy(index, currSort) {
      if (index == this.sortBarIndex) {
        this.sortBarOrderBy = currSort == "asc" ? "desc" : "asc";
      } else {
        this.sortBarOrderBy = "asc";
      }
      this.sortBarIndex = index;

      this.$emit("sort", this.service.sortBar[index], this.sortBarOrderBy);
    },
  },
};
</script>

<style lang="scss" scoped>
//首页-排序栏
.sort-bar {
  font-size: 0.28rem;
  line-height: 0.8rem;
  height: 0.8rem;
  text-align: center;
  background:#fff;
  display: flex;
  border-bottom: 1px solid #E6E6E6;
  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    .sort-icon {
      background-image: url(../assets/shengji/none.png);
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 0.65em;
      height: 0.8em;
      vertical-align: text-top;
      display: inline-block;
      margin-left:3px;
    }

    .sort-icon.desc {
      background-image: url(../assets/shengji/desc.png);
    }
    .sort-icon.asc {
      background-image: url(../assets/shengji/asc.png);
    }
  }
  div.active {
    color: #4fae54;
  }
}
</style>
